import React, { useEffect, useState } from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const vertical = 'bottom';
const horizontal = 'center';

const SnackbarCore = props => {

    const [open, setopen] = useState(false);

    useEffect(() => {
        if(props.open === true){
            setopen(true)
        }else{
            setopen(false)
        }
    }, [props.open])

    return (
        <>

            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                autoHideDuration={6000}
                onClose={(event) => {
                    setopen(false)
                    if(props.onClose){
                        props.onClose(event)
                    }
                }}
            >
                <Alert variant="filled" elevation={6} severity={props.severity} sx={{ width: '100%', fontWeight: 'normal' }}>
                    {props.message}
                </Alert>
            </Snackbar>

        </>
    );
}

export default SnackbarCore;